import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import {
  LargeModal,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalFooter
} from 'src/components/containers/LargeModal'
import { TranspBtn } from 'src/components/atoms/input/buttons'
import { Product } from '../../../resources'
import { StoreProps } from '../../../stores'
import ProductDetailCard from './ProductDetailCard'
import ProductDetailCardCollapse from './ProductDetailCardCollapse'
import { media } from '../../../utils'

/*
  quantityselect ... shows quantity dropdown
  minQuantity    ... minimum quantity in quantitiy dropdown
  maxQuantity    ... minimum quantity in quantitiy dropdown
  multiselect    ... allows multiple items of the same product type
  autoclose      ... closes modal after product selection (overwritten by multiselect)
*/

interface Props extends StoreProps {
  title: string
  open: boolean
  onClose: () => void
  products: Product[]
  autoclose?: boolean
  quantityselect?: boolean
  quantityFactor?: number
  minQuantity?: number
  maxQuantity?: number
  multiselect?: boolean
  productType?: string
  customQuantities?: Number[]
  openVariantModal?: () => void
}

interface State {
  highlightedProduct: string
}

@inject('confStore')
@observer
export default class ProductModal extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { highlightedProduct: '' }
  }

  setHighlight = (highlight, product?) => {
    this.setState({ highlightedProduct: highlight ? product.uuid : '' })
  }

  setCount = (product, count) => {
    const { confStore } = this.props
    confStore.updateQuantity(product, +count)
  }

  toggleProduct = (product, quantity) => {
    if (product.productType === 'CARD' || product.productType === 'OBITUARY') {
      if (quantity === 1) quantity = 10
    }
    const { autoclose, confStore, multiselect, openVariantModal } = this.props
    if (!confStore.offerHasProduct(product) && multiselect) {
      confStore.addProduct(product, quantity)
    } else {
      confStore.toggleProduct(product, quantity, !!multiselect)
    }
    if (confStore.offerHasProduct(product) && !multiselect && autoclose) {
      this.closeModal()
      if (openVariantModal) {
        openVariantModal()
      }
    }
  }

  closeModal = () => {
    const { onClose } = this.props
    // if (confStore.getProductsInOfferByType('OBITUARY').length > 0) {
    //   if (productType === 'OBITUARY') {
    //     confStore.setActiveEditObituary(false)
    //     setTimeout(
    //       () =>
    //         confStore.changeObituaryDesign(
    //           confStore.getProductsInOfferByType('OBITUARY')[0]
    //         ),
    //       5000
    //     )
    //   }
    // }

    // if (confStore.getProductsInOfferByType('CARD').length > 0) {
    //   if (productType === 'CARD') {
    //     confStore.setActiveEditCard(false)
    //     setTimeout(
    //       () =>
    //         confStore.changeCardDesign(
    //           confStore.getProductsInOfferByType('CARD')[0]
    //         ),
    //       5000
    //     )
    //   }
    // }
    this.setHighlight(false)
    onClose()
  }
  checkExistCategory = (products, category) => {
    for (let i = 0; i < products.length; i++) {
      if (products[i].category === category) {
        return true
      }
    }
    return false
  }
  renderProductDetailCard = (p, productInOffer, highlight) => {
    const {
      autoclose,
      quantityselect,
      quantityFactor,
      minQuantity,
      maxQuantity,
      customQuantities
    } = this.props
    return (
      <React.Fragment key={`${p.uuid}_fragment`}>
        <ProductDetailCard
          key={p.uuid}
          product={p}
          count={productInOffer ? productInOffer.quantity : 1}
          selected={!!productInOffer}
          highlight={highlight}
          autoclose={autoclose}
          quantityselect={quantityselect}
          quantityFactor={quantityFactor}
          minQuantity={minQuantity}
          maxQuantity={maxQuantity}
          customQuantities={customQuantities}
          onSelect={this.toggleProduct}
          onQuantitySelect={this.setCount}
          setHighlight={this.setHighlight}
        />
        {highlight && (
          <ProductDetailCardCollapse
            key={`${p.uuid}_collapse`}
            product={p}
            count={productInOffer ? productInOffer.quantity : 1}
            selected={!!productInOffer}
            highlight={highlight}
            autoclose={autoclose}
            quantityselect={quantityselect}
            quantityFactor={quantityFactor}
            minQuantity={minQuantity}
            maxQuantity={maxQuantity}
            onSelect={this.toggleProduct}
            onQuantitySelect={this.setCount}
            setHighlight={this.setHighlight}
          />
        )}
      </React.Fragment>
    )
  }

  render() {
    const { confStore, open, products, title, productType } = this.props
    const { highlightedProduct } = this.state
    let productsCategories = [
      {
        category: 'STANDARD',
        title: 'Standard',
        COFFIN: 'Die traditionelle Wahl für einen würdevollen Abschied.',
        URN: 'Traditionelle Urnen für einen würdevollen Abschied'
      },
      {
        category: 'CLASSIC',
        title: 'Klassisch',
        COFFIN: 'Die edle Wahl für eine feierliche Aufbahrung.',
        URN: 'Edle Urnenmodelle in eleganten Formen.'
      },
      {
        category: 'PREMIUM',
        title: 'Premium',
        COFFIN: 'Die luxuriöse Wahl für eine exklusive Zeremonie.',
        URN: 'Luxuriöse Urnen aus erlesenen Materialien'
      },
      {
        category: 'COFFIN_ARRANGEMENT',
        title: 'Sarggestecke',
        FLOWER: 'Edle Gestecke für eine schöne Erscheinung des Sarges.'
      },
      {
        category: 'WREATHS',
        title: 'Trauerkränze',
        FLOWER: 'Klassische Kränze für einen würdevollen Abschied.'
      },
      {
        category: 'URN_WREATHS',
        title: 'Urnenkränze',
        FLOWER: 'Stilvolle Kränze, die Urnen geschmackvoll umschmeicheln.'
      },
      {
        category: 'HEART_WREATHS',
        title: 'Trauerherzen',
        FLOWER: 'Ästhetische Blumenherzen als Zeichen der Liebe'
      },
      {
        category: 'ASHES',
        title: 'Erinnerungen aus Asche',
        MEMORIAL: 'Einen Teil der Asche als Erinnerung aufbewahren.'
      },
      {
        category: 'COMMEMORATIVE_LIGHTS',
        title: 'Gedenklichter',
        MEMORIAL: 'Gedenklichter zur Aufbewahrung von Erinnerungen.'
      },
      {
        category: 'FINGERPRINTS',
        title: 'Fingerabdrücke',
        MEMORIAL: 'Fingerabdrücke in zeitlose Schmuckstücke verwandeln.'
      },
      {
        category: 'DIAMONDS',
        title: 'Edelsteine',
        MEMORIAL: 'Kostbare Edelsteine aus Asche bzw. Haaren herstellen.'
      },
      {
        category: null,
        title: 'Flowers without category',
        FLOWER: 'Flowers without category subtitle'
      },
      {
        category: 'BOUQUETS',
        title: 'Buketts',
        FLOWER: 'Schöne Buketts als kleine Wertschätzung eines lieben Menschen.'
      },

      {
        category: 'CROSSES',
        title: 'Grabkreuze',
        TOMBS: 'Würdevolle Grabkreuze aus Holz.'
      },
      {
        category: 'TOMBSTONES',
        title: 'Grabsteine',
        TOMBS: 'Individuelle und stilvolle Grabanlagen und Grabsteine'
      },
      {
        category: 'MASON_OTHER',
        title: 'Sonstige Steinmetzleistungen',
        TOMBS: 'Weitere Leistungen aller Art'
      },
      {
        category: 'OTHER',
        title: 'Sonstiges',
        FLOWER: 'Liebevolle Abrundung einer schönen Trauerfeier.'
      },
      {
        category: 'ECONOMIC',
        title: 'Preisbewusst',
        COFFIN: 'Die schlichte Wahl für ein kleines Budget.',
        URN: 'Schlichte Urnen für ein kleines Budget'
      }
    ]

    let displayCategories = confStore.getOffer.location.displayCategories
    if (!products) return null
    return (
      <LargeModal
        animation={false}
        open={open}
        type={productType}
        onHide={this.closeModal}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ChangeButton onClick={this.closeModal} id='close-modal'>
            Übernehmen
          </ChangeButton>
        </ModalHeader>
        <ModalContent>
          {(displayCategories && productType === 'COFFIN') ||
          productType === 'URN' ||
          productType === 'FLOWER' ||
          productType === 'TOMBS' ||
          productType === 'MEMORIAL' ? (
            <React.Fragment>
              {productsCategories.map((item, index) => {
                if (
                  this.checkExistCategory(products, item.category) &&
                  item.category !== null
                ) {
                  return (
                    <CategoryContainer>
                      <CategoryTitle>{item.title}</CategoryTitle>
                      <CategorySubTitle>{item[productType]}</CategorySubTitle>
                      <GridContainer>
                        {products.map((p) => {
                          if (p.category === item.category) {
                            const highlight = p.uuid === highlightedProduct
                            const productInOffer = confStore.getProductInOffer(
                              p.uuid
                            )
                            return this.renderProductDetailCard(
                              p,
                              productInOffer,
                              highlight
                            )
                          }
                        })}
                      </GridContainer>
                    </CategoryContainer>
                  )
                } else {
                  return <></>
                }
              })}
            </React.Fragment>
          ) : displayCategories && productType === 'COFFIN_LINING' ? (
            <>
              {' '}
              {productsCategories.map((item, index) => {
                if (
                  this.checkExistCategory(products, item.category) &&
                  item.category !== null
                ) {
                  return (
                    <>
                      <CategoryContainer>
                        <GridContainer>
                          {products
                            .filter((item) => item.category !== 'OTHER')
                            .map((p) => {
                              const highlight = p.uuid === highlightedProduct
                              const productInOffer = confStore.getProductInOffer(
                                p.uuid
                              )
                              return this.renderProductDetailCard(
                                p,
                                productInOffer,
                                highlight
                              )
                            })}
                        </GridContainer>
                      </CategoryContainer>

                      <CategoryContainer>
                        <GridContainer>
                          {products
                            .filter((item) => item.category === 'OTHER')
                            .map((p) => {
                              const highlight = p.uuid === highlightedProduct
                              const productInOffer = confStore.getProductInOffer(
                                p.uuid
                              )
                              return this.renderProductDetailCard(
                                p,
                                productInOffer,
                                highlight
                              )
                            })}
                        </GridContainer>
                      </CategoryContainer>
                    </>
                  )
                }
              })}
            </>
          ) : (
            <GridContainer>
              {products.map((p) => {
                const highlight = p.uuid === highlightedProduct
                const productInOffer = confStore.getProductInOffer(p.uuid)
                return this.renderProductDetailCard(
                  p,
                  productInOffer,
                  highlight
                )
              })}
            </GridContainer>
          )}
        </ModalContent>
        <ModalFooter>
          <TranspBtn onClick={this.closeModal}>Übernehmen</TranspBtn>
        </ModalFooter>
      </LargeModal>
    )
  }
}

const ChangeButton = styled.button`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #677d7f;
  background-color: transparent;
  border: 1.5px solid #677d7f;
  padding: 7.5px 30px;
  font-size: 16px;
  transition: all 0.25s ease-in-out;
  transition-property: background-color, border-color, color;

  &:hover {
    color: white;
    background-color: #974353;
    border-color: #974353;
  }

  ${media.tablet`
    position: relative;
    right: 0;
    transform: none;
    margin-top: 15px;

  `}
`

const CategoryContainer = styled.div`
  width: 100%;
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid #d5e4e6;
  &:last-child {
    margin-bottom: 0px;
    border-bottom: 0px none;
  }
`

const CategoryTitle = styled.p`
  font-size: 26px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
`
const CategorySubTitle = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 32px;
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  grid-gap: 15px;
  grid-auto-flow: dense;
  ${media.tablet`
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  `}
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ProductModal.tsx